import React from 'react';
import PropTypes from 'prop-types';
import {
    ButtonContainer,
    PrimaryButton,
    SecondaryButton,
} from '../../styles/navigationButton.style';

const NavigationButtons = ({ onSecondaryButtonClick, getStartedCtaLink }) => {
    return (
        <ButtonContainer>
            <SecondaryButton onClick={onSecondaryButtonClick}>Contact Us</SecondaryButton>
            <PrimaryButton href={getStartedCtaLink} target="_blank" rel="noreferrer">
                Get Started
            </PrimaryButton>
        </ButtonContainer>
    );
};

NavigationButtons.propTypes = {
    onSecondaryButtonClick: PropTypes.func,
    getStartedCtaLink: PropTypes.string,
};

export default NavigationButtons;
